export default __webpack_public_path__ + "static/media/cp_geo_tw.0e99b0ca.svg";